import {
  deleteStyle,
  getCustomEmailBrand,
  updateSender,
} from '@modusign/openapi-client-notification';
import { all, call, put, takeLatest, takeLeading } from 'redux-saga/effects';

import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';
import workspaceService from '@app/libs/workspaceService';
import {
  CUSTOM_BRAND_SETTING__EMAIL_SENDER_UPDATE_REQUEST,
  CUSTOM_BRAND_SETTING__EMAIL_STYLE_FETCH_REQUEST,
  CUSTOM_BRAND_SETTING__EMAIL_STYLE_RESET_REQUEST,
  CUSTOM_BRAND_SETTING__EMAIL_STYLE_RESET_SUCCESS,
} from '@app/store/actionTypes';
import { modalOpen } from '@app/store/modal/actions';

import {
  fetchEmailStyleFailure,
  fetchEmailStyleSuccess,
  resetEmailStyleFailure,
  resetEmailStyleSuccess,
  updateEmailSender,
  updateEmailSenderFailure,
  updateEmailSenderSuccess,
} from './state';
import EmailStyle from './types/EmailStyle';

export function* fetchEmailStyleSaga() {
  try {
    const {
      result: { emailBrand },
    }: { result: { emailBrand: EmailStyle } } = yield call(
      getCustomEmailBrand,
      workspaceService.getWorkspaceId()
    );
    yield put(fetchEmailStyleSuccess({ emailBrand }));
  } catch (error) {
    yield put(fetchEmailStyleFailure(error));
    yield put(
      modalOpen('CONFIRM', {
        content: GLOBAL_ERROR_MESSAGE[error.message] || error.message,
      })
    );
  }
}

export function* resetEmailStyleSaga() {
  try {
    yield call(deleteStyle, workspaceService.getWorkspaceId());
    yield put(
      modalOpen('CONFIRM', {
        title: '설정 완료',
        content:
          '이메일 스타일이 기본 이메일 스타일로 설정되었습니다.\n' +
          '이후 전송되는 모든 이메일에 적용됩니다.',
      })
    );
    yield put(resetEmailStyleSuccess());
  } catch (error) {
    yield put(
      modalOpen('CONFIRM', {
        content: GLOBAL_ERROR_MESSAGE[error.message] || error.message,
      })
    );
    yield put(resetEmailStyleFailure());
  }
}
export function* updateEmailSenderSaga({
  payload: { senderName },
}: ReturnType<typeof updateEmailSender>) {
  try {
    yield call(updateSender, workspaceService.getWorkspaceId(), { senderName });

    yield put(updateEmailSenderSuccess(senderName));
  } catch (error) {
    yield put(
      modalOpen('CONFIRM', {
        content: GLOBAL_ERROR_MESSAGE[error.message] || error.message,
      })
    );
    yield put(updateEmailSenderFailure());
  }
}

export default function* customEmailSettingSaga() {
  yield all([
    takeLatest(
      [
        CUSTOM_BRAND_SETTING__EMAIL_STYLE_FETCH_REQUEST,
        CUSTOM_BRAND_SETTING__EMAIL_STYLE_RESET_SUCCESS,
      ],
      fetchEmailStyleSaga
    ),
    takeLeading(CUSTOM_BRAND_SETTING__EMAIL_STYLE_RESET_REQUEST, resetEmailStyleSaga),
    takeLeading(CUSTOM_BRAND_SETTING__EMAIL_SENDER_UPDATE_REQUEST, updateEmailSenderSaga),
  ]);
}
